/* tslint:disable */
/* eslint-disable */
/**
 * grpc/client_data/client-data.service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { ClientDataServiceAddClientFileBody } from '../models'
// @ts-ignore
import { ClientDataServiceAddClientTagBody } from '../models'
// @ts-ignore
import { ClientDataServiceAddManagerNoteBody } from '../models'
// @ts-ignore
import { ClientDataServiceCreateClientTaskBody } from '../models'
// @ts-ignore
import { ClientDataServiceLogClientFileDownloadBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateArchiveReasonBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateClientBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateClientFileBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateClientTaskBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateCountryBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateLeadSourceBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateManagerNoteBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1AddClientFileResponse } from '../models'
// @ts-ignore
import { V1BulkUpdateClientsRequest } from '../models'
// @ts-ignore
import { V1BulkUpdateClientsResponse } from '../models'
// @ts-ignore
import { V1Client } from '../models'
// @ts-ignore
import { V1ClientTagsResponse } from '../models'
// @ts-ignore
import { V1ClientTask } from '../models'
// @ts-ignore
import { V1CreateArchiveReasonRequest } from '../models'
// @ts-ignore
import { V1CreateArchiveReasonResponse } from '../models'
// @ts-ignore
import { V1CreateCountryRequest } from '../models'
// @ts-ignore
import { V1CreateCountryResponse } from '../models'
// @ts-ignore
import { V1CreateLeadSourceRequest } from '../models'
// @ts-ignore
import { V1CreateLeadSourceResponse } from '../models'
// @ts-ignore
import { V1DashboardMetricsResponse } from '../models'
// @ts-ignore
import { V1GetArchiveReasonsResponse } from '../models'
// @ts-ignore
import { V1GetCountriesResponse } from '../models'
// @ts-ignore
import { V1GetLeadSourcesResponse } from '../models'
// @ts-ignore
import { V1GetManagersResponse } from '../models'
// @ts-ignore
import { V1GetTagsResponse } from '../models'
// @ts-ignore
import { V1ListArchiveReasonsResponse } from '../models'
// @ts-ignore
import { V1ListClientChangeLogsResponse } from '../models'
// @ts-ignore
import { V1ListClientDataResponse } from '../models'
// @ts-ignore
import { V1ListClientFilesResponse } from '../models'
// @ts-ignore
import { V1ListClientTasksResponse } from '../models'
// @ts-ignore
import { V1ListCountriesResponse } from '../models'
// @ts-ignore
import { V1ListLeadSourcesResponse } from '../models'
// @ts-ignore
import { V1ManagerNote } from '../models'
// @ts-ignore
import { V1ResolveUsersRequest } from '../models'
// @ts-ignore
import { V1ResolveUsersResponse } from '../models'
// @ts-ignore
import { V1SearchCitiesResponse } from '../models'
// @ts-ignore
import { V1TransferManagerClientsRequest } from '../models'
// @ts-ignore
import { V1TransferManagerClientsResponse } from '../models'
// @ts-ignore
import { V1UpdateArchiveReasonResponse } from '../models'
// @ts-ignore
import { V1UpdateClientFileResponse } from '../models'
// @ts-ignore
import { V1UpdateCountryResponse } from '../models'
// @ts-ignore
import { V1UpdateLeadSourceResponse } from '../models'
/**
 * ClientDataServiceApi - axios parameter creator
 * @export
 */
export const ClientDataServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary AddClientFile добавляет метаданные файла к клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientFile: async (
      clientId: string,
      body: ClientDataServiceAddClientFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceAddClientFile', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceAddClientFile', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/files`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary AddClientTag вешает тег на клиента (DEV-1062), RemoveClientTag снимает.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientTagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientTag: async (
      clientId: string,
      body: ClientDataServiceAddClientTagBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceAddClientTag', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceAddClientTag', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/tags`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary AddManagerNote добавляет новую заметку менеджера к клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceAddManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddManagerNote: async (
      clientId: string,
      body: ClientDataServiceAddManagerNoteBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceAddManagerNote', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceAddManagerNote', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/notes`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary BulkUpdateClients массово обновляет stage и/или ответственного менеджера для списка клиентов.
     * @param {V1BulkUpdateClientsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceBulkUpdateClients: async (
      body: V1BulkUpdateClientsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceBulkUpdateClients', 'body', body)
      const localVarPath = `/api/v1/clients/bulk-update`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {V1CreateArchiveReasonRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateArchiveReason: async (
      body: V1CreateArchiveReasonRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceCreateArchiveReason', 'body', body)
      const localVarPath = `/api/v1/admin/references/archive-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateClient используется для создания \"полноценного\" клиента из CRM.
     * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClient: async (
      client: V1Client,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'client' is not null or undefined
      assertParamExists('clientDataServiceCreateClient', 'client', client)
      const localVarPath = `/api/v1/clients`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        client,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateClientFromFormData используется для создания клиента из формы на сайте.
     * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClientFromFormData: async (
      client: V1Client,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'client' is not null or undefined
      assertParamExists('clientDataServiceCreateClientFromFormData', 'client', client)
      const localVarPath = `/api/v1/clients/form-data`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        client,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateClientTask создаёт задачу по клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceCreateClientTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClientTask: async (
      clientId: string,
      body: ClientDataServiceCreateClientTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceCreateClientTask', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceCreateClientTask', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/tasks`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {V1CreateCountryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateCountry: async (
      body: V1CreateCountryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceCreateCountry', 'body', body)
      const localVarPath = `/api/v1/admin/references/countries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {V1CreateLeadSourceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateLeadSource: async (
      body: V1CreateLeadSourceRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceCreateLeadSource', 'body', body)
      const localVarPath = `/api/v1/admin/references/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteArchiveReason: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceDeleteArchiveReason', 'id', id)
      const localVarPath = `/api/v1/admin/references/archive-reasons/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteClientContact удаляет контакт клиента по ID.
     * @param {string} clientId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientContact: async (
      clientId: string,
      contactId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientContact', 'clientId', clientId)
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientContact', 'contactId', contactId)
      const localVarPath = `/api/v1/clients/{clientId}/contacts/{contactId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'contactId'}}`, encodeURIComponent(String(contactId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteClientFile удаляет метаданные файла.
     * @param {string} clientId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientFile: async (
      clientId: string,
      fileId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientFile', 'clientId', clientId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientFile', 'fileId', fileId)
      const localVarPath = `/api/v1/clients/{clientId}/files/{fileId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteClientTask удаляет задачу (soft delete).
     * @param {string} clientId
     * @param {string} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientTask: async (
      clientId: string,
      taskId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientTask', 'clientId', clientId)
      // verify required parameter 'taskId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientTask', 'taskId', taskId)
      const localVarPath = `/api/v1/clients/{clientId}/tasks/{taskId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'taskId'}}`, encodeURIComponent(String(taskId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteCountry: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceDeleteCountry', 'id', id)
      const localVarPath = `/api/v1/admin/references/countries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteLeadSource: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceDeleteLeadSource', 'id', id)
      const localVarPath = `/api/v1/admin/references/lead-sources/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteManagerNote удаляет заметку менеджера.
     * @param {string} clientId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteManagerNote: async (
      clientId: string,
      noteId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceDeleteManagerNote', 'clientId', clientId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('clientDataServiceDeleteManagerNote', 'noteId', noteId)
      const localVarPath = `/api/v1/clients/{clientId}/notes/{noteId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'noteId'}}`, encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetArchiveReasons возвращает справочник причин архивации клиента (DEV-1061).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetArchiveReasons: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/archive-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetClient возвращает полную карточку одного клиента по его ID.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetClient: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceGetClient', 'id', id)
      const localVarPath = `/api/v1/clients/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetCountriesReferences возвращает список стран из справочника.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetCountriesReferences: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/countries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetDashboardMetrics возвращает метрики для дашборда (общее количество клиентов, прирост).
     * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - месяц) \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetDashboardMetrics: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/dashboard-metrics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLeadSources возвращает список доступных источников лидов.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetLeadSources: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetManagers возвращает список менеджеров (доступен только для admin и hos).
     * @param {string} [role] manager (default) | support_manager
     * @param {boolean} [activeOnly] active_only&#x3D;true — только активные пользователи (DEV-717): для выбора, кому назначить/передать клиентов. По умолчанию false — отдаём всех носителей роли, включая уволенных: они нужны фильтрам и резолву имён (crm-vue).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetManagers: async (
      role?: string,
      activeOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/managers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (role !== undefined) {
        localVarQueryParameter['role'] = role
      }

      if (activeOnly !== undefined) {
        localVarQueryParameter['activeOnly'] = activeOnly
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetTags возвращает справочник тегов клиента (DEV-1062).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/tags`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ARCHIVE REASONS CRUD (DEV-1061)
     * @param {boolean} [includeInactive] Включать ли неактивные причины
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListArchiveReasonsAdmin: async (
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/references/archive-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListClientChangeLogs возвращает историю изменений клиента.
     * @param {string} clientId UUID клиента (обязательно)
     * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Фильтр по типу действия (опционально)   - CLIENT_CHANGE_ACTION_TYPE_CREATED: Клиент создан  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Поля клиента обновлены  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: Этап изменён  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: Статус изменён  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: Задача создана  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: Задача обновлена  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: Задача выполнена  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: Задача удалена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: Заметка добавлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: Заметка обновлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: Заметка удалена  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: Менеджер назначен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: Контакт добавлен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: Контакт удалён  - CLIENT_CHANGE_ACTION_TYPE_DELETED: Клиент удалён  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: Файл загружен  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: Файл скачан
     * @param {number} [limit] Лимит записей (по умолчанию 50)
     * @param {number} [offset] Смещение для пагинации
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientChangeLogs: async (
      clientId: string,
      actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceListClientChangeLogs', 'clientId', clientId)
      const localVarPath = `/api/v1/clients/{clientId}/change-logs`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (actionType !== undefined) {
        localVarQueryParameter['actionType'] = actionType
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListClientData возвращает список клиентов с пагинацией.
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [responsibleManagerId] Существующие фильтры
     * @param {string} [leadSource]
     * @param {Array<string>} [statuses] 1.2.9.2.1. Фильтрация по множественным статусам (передаются UUID статусов)
     * @param {Array<string>} [leadSources] 1.2.9.2.2. Фильтрация по множественным источникам лидов (передаются UUID источников)
     * @param {string} [dateFrom] 1.2.9.2.3. Фильтрация по диапазону дат создания
     * @param {string} [dateTo]
     * @param {string} [searchQuery] 1.2.9.2.4. Полнотекстовый поиск по имени, email, телефону
     * @param {string} [language] 1.2.9.2.6. Фильтрация по языку общения клиента
     * @param {boolean} [hasDeal] 1.2.9.2.7. Фильтрация по наличию сделки true &#x3D; только клиенты со сделкой, false &#x3D; только без сделки, не указано &#x3D; все
     * @param {boolean} [isArchived] 1.2.9.2.8. Фильтрация по архивации true &#x3D; только архивные, false/не указано &#x3D; только активные
     * @param {boolean} [hasResponsibleManager] DEV-142. Фильтрация по наличию ответственного менеджера. true &#x3D; только клиенты с назначенным менеджером, false &#x3D; только без менеджера, не указано &#x3D; без фильтра. Используется пресетами «Мои/Без ответственного» для admin/hos на фронте; для не-admin/hos фильтр игнорируется по бизнес-логике.
     * @param {string} [agentId] DEV-232. Фильтр по агенту, приведшему клиента (clients.agent_id). UUID агента из auth.
     * @param {boolean} [hasAgent] DEV-281. Фильтрация по наличию агента, приведшего клиента (пресет «Агентские»). true &#x3D; только клиенты с агентом (clients.agent_id IS NOT NULL), false &#x3D; только без агента, не указано &#x3D; без фильтра.
     * @param {string} [agentDuplicateStatus] DEV-1005. Фильтр по статусу дубля от агента (clients.agent_duplicate_status). Значения: not_checked|unique|duplicate_pending|duplicate_confirmed|rejected. Пресет «Дубли» на фронте передаёт \&#39;duplicate_pending\&#39;. Скоуп по роли (rbac_helper) применяется поверх: manager видит только своих, admin/hos — всех.
     * @param {Array<string>} [tagKeys] DEV-1062. Фильтр по тегам клиента (client_tags.key): WARMING, TEST, AGENT_LEAD, DUPLICATE. Несколько ключей &#x3D; OR (клиент имеет хотя бы один из тегов).
     * @param {Array<string>} [archiveReasonIds] DEV-1061. Фильтр по причине архивации (clients.archive_reason_id, справочник archive_reasons). Несколько причин &#x3D; OR. Осмыслен вместе с is_archived&#x3D;true.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientData: async (
      paginationPage?: string,
      paginationPerPage?: string,
      responsibleManagerId?: string,
      leadSource?: string,
      statuses?: Array<string>,
      leadSources?: Array<string>,
      dateFrom?: string,
      dateTo?: string,
      searchQuery?: string,
      language?: string,
      hasDeal?: boolean,
      isArchived?: boolean,
      hasResponsibleManager?: boolean,
      agentId?: string,
      hasAgent?: boolean,
      agentDuplicateStatus?: string,
      tagKeys?: Array<string>,
      archiveReasonIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/clients`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (responsibleManagerId !== undefined) {
        localVarQueryParameter['responsibleManagerId'] = responsibleManagerId
      }

      if (leadSource !== undefined) {
        localVarQueryParameter['leadSource'] = leadSource
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses
      }

      if (leadSources) {
        localVarQueryParameter['leadSources'] = leadSources
      }

      if (dateFrom !== undefined) {
        localVarQueryParameter['dateFrom'] =
          (dateFrom as any) instanceof Date ? (dateFrom as any).toISOString() : dateFrom
      }

      if (dateTo !== undefined) {
        localVarQueryParameter['dateTo'] =
          (dateTo as any) instanceof Date ? (dateTo as any).toISOString() : dateTo
      }

      if (searchQuery !== undefined) {
        localVarQueryParameter['searchQuery'] = searchQuery
      }

      if (language !== undefined) {
        localVarQueryParameter['language'] = language
      }

      if (hasDeal !== undefined) {
        localVarQueryParameter['hasDeal'] = hasDeal
      }

      if (isArchived !== undefined) {
        localVarQueryParameter['isArchived'] = isArchived
      }

      if (hasResponsibleManager !== undefined) {
        localVarQueryParameter['hasResponsibleManager'] = hasResponsibleManager
      }

      if (agentId !== undefined) {
        localVarQueryParameter['agentId'] = agentId
      }

      if (hasAgent !== undefined) {
        localVarQueryParameter['hasAgent'] = hasAgent
      }

      if (agentDuplicateStatus !== undefined) {
        localVarQueryParameter['agentDuplicateStatus'] = agentDuplicateStatus
      }

      if (tagKeys) {
        localVarQueryParameter['tagKeys'] = tagKeys
      }

      if (archiveReasonIds) {
        localVarQueryParameter['archiveReasonIds'] = archiveReasonIds
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListClientFiles возвращает список файлов клиента.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientFiles: async (
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceListClientFiles', 'clientId', clientId)
      const localVarPath = `/api/v1/clients/{clientId}/files`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListClientTasks возвращает задачи клиента.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientTasks: async (
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceListClientTasks', 'clientId', clientId)
      const localVarPath = `/api/v1/clients/{clientId}/tasks`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary COUNTRIES CRUD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListCountriesAdmin: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/references/countries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary LEAD SOURCES CRUD
     * @param {boolean} [includeInactive] Включать ли неактивные источники
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListLeadSourcesAdmin: async (
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/references/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary LogClientFileDownload логирует скачивание файла клиента.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceLogClientFileDownloadBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceLogClientFileDownload: async (
      clientId: string,
      fileId: string,
      body: ClientDataServiceLogClientFileDownloadBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceLogClientFileDownload', 'clientId', clientId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('clientDataServiceLogClientFileDownload', 'fileId', fileId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceLogClientFileDownload', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/files/{fileId}/download-log`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} clientId
     * @param {string} tagKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceRemoveClientTag: async (
      clientId: string,
      tagKey: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceRemoveClientTag', 'clientId', clientId)
      // verify required parameter 'tagKey' is not null or undefined
      assertParamExists('clientDataServiceRemoveClientTag', 'tagKey', tagKey)
      const localVarPath = `/api/v1/clients/{clientId}/tags/{tagKey}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'tagKey'}}`, encodeURIComponent(String(tagKey)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ResolveUsers — батч-резолв ФИО пользователей по id (вкл. уволенных), DEV-395. Любой аутентифицированный: имена менеджеров показываются на всех ролевых экранах (доски, списки), не только в hos/admin-отчётах.
     * @param {V1ResolveUsersRequest} body ResolveUsersRequest — батч-резолв ФИО пользователей по id (DEV-395), включая уволенных (soft-deleted): для отображения исторических ссылок на менеджеров в лидерборде/дашборде/сделках/клиентах. Доступен любому аутентифицированному.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceResolveUsers: async (
      body: V1ResolveUsersRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceResolveUsers', 'body', body)
      const localVarPath = `/api/v1/references/users/resolve`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SearchCities выполняет поиск городов по названию с поддержкой FTS.
     * @param {string} [query] Минимум 2 символа для поиска
     * @param {string} [countryId] Фильтр по стране (UUID)
     * @param {number} [limit] Лимит результатов (по умолчанию 10, макс 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceSearchCities: async (
      query?: string,
      countryId?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/cities/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (countryId !== undefined) {
        localVarQueryParameter['countryId'] = countryId
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary TransferManagerClients передаёт весь живой портфель одного менеджера другому (DEV-717). Архивных и удалённых клиентов не трогает; активные сделки переезжают следом за клиентами.
     * @param {V1TransferManagerClientsRequest} body Запрос на передачу портфеля менеджера (DEV-717): все живые клиенты from_manager_id переезжают на to_manager_id. Архивные и удалённые клиенты остаются на прежнем менеджере.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceTransferManagerClients: async (
      body: V1TransferManagerClientsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceTransferManagerClients', 'body', body)
      const localVarPath = `/api/v1/clients/transfer-manager`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateArchiveReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateArchiveReason: async (
      id: string,
      body: ClientDataServiceUpdateArchiveReasonBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceUpdateArchiveReason', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateArchiveReason', 'body', body)
      const localVarPath = `/api/v1/admin/references/archive-reasons/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateClient обновляет отдельные поля клиента (частичное обновление).
     * @param {string} clientId
     * @param {ClientDataServiceUpdateClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClient: async (
      clientId: string,
      body: ClientDataServiceUpdateClientBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClient', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateClient', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateClientFile обновляет метаданные файла (например, display_name).
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceUpdateClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClientFile: async (
      clientId: string,
      fileId: string,
      body: ClientDataServiceUpdateClientFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientFile', 'clientId', clientId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientFile', 'fileId', fileId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientFile', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/files/{fileId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateClientTask частично обновляет задачу (описание/срок/исполнитель/выполнение).
     * @param {string} clientId
     * @param {string} taskId
     * @param {ClientDataServiceUpdateClientTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClientTask: async (
      clientId: string,
      taskId: string,
      body: ClientDataServiceUpdateClientTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientTask', 'clientId', clientId)
      // verify required parameter 'taskId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientTask', 'taskId', taskId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientTask', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/tasks/{taskId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'taskId'}}`, encodeURIComponent(String(taskId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateCountryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateCountry: async (
      id: string,
      body: ClientDataServiceUpdateCountryBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceUpdateCountry', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateCountry', 'body', body)
      const localVarPath = `/api/v1/admin/references/countries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateLeadSourceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateLeadSource: async (
      id: string,
      body: ClientDataServiceUpdateLeadSourceBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceUpdateLeadSource', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateLeadSource', 'body', body)
      const localVarPath = `/api/v1/admin/references/lead-sources/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateManagerNote обновляет существующую заметку менеджера.
     * @param {string} clientId
     * @param {string} noteId
     * @param {ClientDataServiceUpdateManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateManagerNote: async (
      clientId: string,
      noteId: string,
      body: ClientDataServiceUpdateManagerNoteBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceUpdateManagerNote', 'clientId', clientId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('clientDataServiceUpdateManagerNote', 'noteId', noteId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateManagerNote', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/notes/{noteId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'noteId'}}`, encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ClientDataServiceApi - functional programming interface
 * @export
 */
export const ClientDataServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ClientDataServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary AddClientFile добавляет метаданные файла к клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceAddClientFile(
      clientId: string,
      body: ClientDataServiceAddClientFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddClientFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceAddClientFile(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceAddClientFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary AddClientTag вешает тег на клиента (DEV-1062), RemoveClientTag снимает.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientTagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceAddClientTag(
      clientId: string,
      body: ClientDataServiceAddClientTagBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientTagsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceAddClientTag(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceAddClientTag']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary AddManagerNote добавляет новую заметку менеджера к клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceAddManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceAddManagerNote(
      clientId: string,
      body: ClientDataServiceAddManagerNoteBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ManagerNote>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceAddManagerNote(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceAddManagerNote']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary BulkUpdateClients массово обновляет stage и/или ответственного менеджера для списка клиентов.
     * @param {V1BulkUpdateClientsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceBulkUpdateClients(
      body: V1BulkUpdateClientsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1BulkUpdateClientsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceBulkUpdateClients(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceBulkUpdateClients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {V1CreateArchiveReasonRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateArchiveReason(
      body: V1CreateArchiveReasonRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateArchiveReasonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceCreateArchiveReason(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateArchiveReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateClient используется для создания \"полноценного\" клиента из CRM.
     * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateClient(
      client: V1Client,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceCreateClient(
        client,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateClient']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateClientFromFormData используется для создания клиента из формы на сайте.
     * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateClientFromFormData(
      client: V1Client,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceCreateClientFromFormData(client, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateClientFromFormData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateClientTask создаёт задачу по клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceCreateClientTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateClientTask(
      clientId: string,
      body: ClientDataServiceCreateClientTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceCreateClientTask(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateClientTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {V1CreateCountryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateCountry(
      body: V1CreateCountryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateCountryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceCreateCountry(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateCountry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {V1CreateLeadSourceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateLeadSource(
      body: V1CreateLeadSourceRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateLeadSourceResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceCreateLeadSource(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateLeadSource']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteArchiveReason(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceDeleteArchiveReason(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteArchiveReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteClientContact удаляет контакт клиента по ID.
     * @param {string} clientId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteClientContact(
      clientId: string,
      contactId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceDeleteClientContact(
          clientId,
          contactId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteClientContact']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteClientFile удаляет метаданные файла.
     * @param {string} clientId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteClientFile(
      clientId: string,
      fileId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteClientFile(
        clientId,
        fileId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteClientFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteClientTask удаляет задачу (soft delete).
     * @param {string} clientId
     * @param {string} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteClientTask(
      clientId: string,
      taskId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteClientTask(
        clientId,
        taskId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteClientTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteCountry(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteCountry(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteCountry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteLeadSource(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteLeadSource(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteLeadSource']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteManagerNote удаляет заметку менеджера.
     * @param {string} clientId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteManagerNote(
      clientId: string,
      noteId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteManagerNote(
        clientId,
        noteId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteManagerNote']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetArchiveReasons возвращает справочник причин архивации клиента (DEV-1061).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetArchiveReasons(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetArchiveReasonsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetArchiveReasons(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetArchiveReasons']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetClient возвращает полную карточку одного клиента по его ID.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetClient(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceGetClient(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetClient']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetCountriesReferences возвращает список стран из справочника.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetCountriesReferences(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetCountriesResponse>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetCountriesReferences(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetCountriesReferences']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetDashboardMetrics возвращает метрики для дашборда (общее количество клиентов, прирост).
     * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - месяц) \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetDashboardMetrics(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DashboardMetricsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetDashboardMetrics(period, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLeadSources возвращает список доступных источников лидов.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetLeadSources(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLeadSourcesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetLeadSources(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetLeadSources']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetManagers возвращает список менеджеров (доступен только для admin и hos).
     * @param {string} [role] manager (default) | support_manager
     * @param {boolean} [activeOnly] active_only&#x3D;true — только активные пользователи (DEV-717): для выбора, кому назначить/передать клиентов. По умолчанию false — отдаём всех носителей роли, включая уволенных: они нужны фильтрам и резолву имён (crm-vue).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetManagers(
      role?: string,
      activeOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagersResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceGetManagers(
        role,
        activeOnly,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetManagers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetTags возвращает справочник тегов клиента (DEV-1062).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetTags(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetTagsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceGetTags(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetTags']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ARCHIVE REASONS CRUD (DEV-1061)
     * @param {boolean} [includeInactive] Включать ли неактивные причины
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListArchiveReasonsAdmin(
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListArchiveReasonsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListArchiveReasonsAdmin(
          includeInactive,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListArchiveReasonsAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListClientChangeLogs возвращает историю изменений клиента.
     * @param {string} clientId UUID клиента (обязательно)
     * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Фильтр по типу действия (опционально)   - CLIENT_CHANGE_ACTION_TYPE_CREATED: Клиент создан  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Поля клиента обновлены  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: Этап изменён  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: Статус изменён  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: Задача создана  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: Задача обновлена  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: Задача выполнена  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: Задача удалена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: Заметка добавлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: Заметка обновлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: Заметка удалена  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: Менеджер назначен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: Контакт добавлен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: Контакт удалён  - CLIENT_CHANGE_ACTION_TYPE_DELETED: Клиент удалён  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: Файл загружен  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: Файл скачан
     * @param {number} [limit] Лимит записей (по умолчанию 50)
     * @param {number} [offset] Смещение для пагинации
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListClientChangeLogs(
      clientId: string,
      actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientChangeLogsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListClientChangeLogs(
          clientId,
          actionType,
          limit,
          offset,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListClientChangeLogs']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListClientData возвращает список клиентов с пагинацией.
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [responsibleManagerId] Существующие фильтры
     * @param {string} [leadSource]
     * @param {Array<string>} [statuses] 1.2.9.2.1. Фильтрация по множественным статусам (передаются UUID статусов)
     * @param {Array<string>} [leadSources] 1.2.9.2.2. Фильтрация по множественным источникам лидов (передаются UUID источников)
     * @param {string} [dateFrom] 1.2.9.2.3. Фильтрация по диапазону дат создания
     * @param {string} [dateTo]
     * @param {string} [searchQuery] 1.2.9.2.4. Полнотекстовый поиск по имени, email, телефону
     * @param {string} [language] 1.2.9.2.6. Фильтрация по языку общения клиента
     * @param {boolean} [hasDeal] 1.2.9.2.7. Фильтрация по наличию сделки true &#x3D; только клиенты со сделкой, false &#x3D; только без сделки, не указано &#x3D; все
     * @param {boolean} [isArchived] 1.2.9.2.8. Фильтрация по архивации true &#x3D; только архивные, false/не указано &#x3D; только активные
     * @param {boolean} [hasResponsibleManager] DEV-142. Фильтрация по наличию ответственного менеджера. true &#x3D; только клиенты с назначенным менеджером, false &#x3D; только без менеджера, не указано &#x3D; без фильтра. Используется пресетами «Мои/Без ответственного» для admin/hos на фронте; для не-admin/hos фильтр игнорируется по бизнес-логике.
     * @param {string} [agentId] DEV-232. Фильтр по агенту, приведшему клиента (clients.agent_id). UUID агента из auth.
     * @param {boolean} [hasAgent] DEV-281. Фильтрация по наличию агента, приведшего клиента (пресет «Агентские»). true &#x3D; только клиенты с агентом (clients.agent_id IS NOT NULL), false &#x3D; только без агента, не указано &#x3D; без фильтра.
     * @param {string} [agentDuplicateStatus] DEV-1005. Фильтр по статусу дубля от агента (clients.agent_duplicate_status). Значения: not_checked|unique|duplicate_pending|duplicate_confirmed|rejected. Пресет «Дубли» на фронте передаёт \&#39;duplicate_pending\&#39;. Скоуп по роли (rbac_helper) применяется поверх: manager видит только своих, admin/hos — всех.
     * @param {Array<string>} [tagKeys] DEV-1062. Фильтр по тегам клиента (client_tags.key): WARMING, TEST, AGENT_LEAD, DUPLICATE. Несколько ключей &#x3D; OR (клиент имеет хотя бы один из тегов).
     * @param {Array<string>} [archiveReasonIds] DEV-1061. Фильтр по причине архивации (clients.archive_reason_id, справочник archive_reasons). Несколько причин &#x3D; OR. Осмыслен вместе с is_archived&#x3D;true.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListClientData(
      paginationPage?: string,
      paginationPerPage?: string,
      responsibleManagerId?: string,
      leadSource?: string,
      statuses?: Array<string>,
      leadSources?: Array<string>,
      dateFrom?: string,
      dateTo?: string,
      searchQuery?: string,
      language?: string,
      hasDeal?: boolean,
      isArchived?: boolean,
      hasResponsibleManager?: boolean,
      agentId?: string,
      hasAgent?: boolean,
      agentDuplicateStatus?: string,
      tagKeys?: Array<string>,
      archiveReasonIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientDataResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceListClientData(
        paginationPage,
        paginationPerPage,
        responsibleManagerId,
        leadSource,
        statuses,
        leadSources,
        dateFrom,
        dateTo,
        searchQuery,
        language,
        hasDeal,
        isArchived,
        hasResponsibleManager,
        agentId,
        hasAgent,
        agentDuplicateStatus,
        tagKeys,
        archiveReasonIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListClientData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListClientFiles возвращает список файлов клиента.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListClientFiles(
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientFilesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceListClientFiles(
        clientId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListClientFiles']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListClientTasks возвращает задачи клиента.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListClientTasks(
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientTasksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceListClientTasks(
        clientId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListClientTasks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary COUNTRIES CRUD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListCountriesAdmin(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListCountriesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListCountriesAdmin(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListCountriesAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary LEAD SOURCES CRUD
     * @param {boolean} [includeInactive] Включать ли неактивные источники
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListLeadSourcesAdmin(
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListLeadSourcesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListLeadSourcesAdmin(
          includeInactive,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListLeadSourcesAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary LogClientFileDownload логирует скачивание файла клиента.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceLogClientFileDownloadBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceLogClientFileDownload(
      clientId: string,
      fileId: string,
      body: ClientDataServiceLogClientFileDownloadBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceLogClientFileDownload(
          clientId,
          fileId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceLogClientFileDownload']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} clientId
     * @param {string} tagKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceRemoveClientTag(
      clientId: string,
      tagKey: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientTagsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceRemoveClientTag(
        clientId,
        tagKey,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceRemoveClientTag']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ResolveUsers — батч-резолв ФИО пользователей по id (вкл. уволенных), DEV-395. Любой аутентифицированный: имена менеджеров показываются на всех ролевых экранах (доски, списки), не только в hos/admin-отчётах.
     * @param {V1ResolveUsersRequest} body ResolveUsersRequest — батч-резолв ФИО пользователей по id (DEV-395), включая уволенных (soft-deleted): для отображения исторических ссылок на менеджеров в лидерборде/дашборде/сделках/клиентах. Доступен любому аутентифицированному.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceResolveUsers(
      body: V1ResolveUsersRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ResolveUsersResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceResolveUsers(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceResolveUsers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SearchCities выполняет поиск городов по названию с поддержкой FTS.
     * @param {string} [query] Минимум 2 символа для поиска
     * @param {string} [countryId] Фильтр по стране (UUID)
     * @param {number} [limit] Лимит результатов (по умолчанию 10, макс 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceSearchCities(
      query?: string,
      countryId?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SearchCitiesResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceSearchCities(
        query,
        countryId,
        limit,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceSearchCities']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary TransferManagerClients передаёт весь живой портфель одного менеджера другому (DEV-717). Архивных и удалённых клиентов не трогает; активные сделки переезжают следом за клиентами.
     * @param {V1TransferManagerClientsRequest} body Запрос на передачу портфеля менеджера (DEV-717): все живые клиенты from_manager_id переезжают на to_manager_id. Архивные и удалённые клиенты остаются на прежнем менеджере.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceTransferManagerClients(
      body: V1TransferManagerClientsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TransferManagerClientsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceTransferManagerClients(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceTransferManagerClients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateArchiveReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateArchiveReason(
      id: string,
      body: ClientDataServiceUpdateArchiveReasonBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateArchiveReasonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceUpdateArchiveReason(id, body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateArchiveReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateClient обновляет отдельные поля клиента (частичное обновление).
     * @param {string} clientId
     * @param {ClientDataServiceUpdateClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateClient(
      clientId: string,
      body: ClientDataServiceUpdateClientBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateClient(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateClient']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateClientFile обновляет метаданные файла (например, display_name).
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceUpdateClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateClientFile(
      clientId: string,
      fileId: string,
      body: ClientDataServiceUpdateClientFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateClientFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateClientFile(
        clientId,
        fileId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateClientFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateClientTask частично обновляет задачу (описание/срок/исполнитель/выполнение).
     * @param {string} clientId
     * @param {string} taskId
     * @param {ClientDataServiceUpdateClientTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateClientTask(
      clientId: string,
      taskId: string,
      body: ClientDataServiceUpdateClientTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateClientTask(
        clientId,
        taskId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateClientTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateCountryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateCountry(
      id: string,
      body: ClientDataServiceUpdateCountryBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateCountryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateCountry(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateCountry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateLeadSourceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateLeadSource(
      id: string,
      body: ClientDataServiceUpdateLeadSourceBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateLeadSourceResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateLeadSource(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateLeadSource']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateManagerNote обновляет существующую заметку менеджера.
     * @param {string} clientId
     * @param {string} noteId
     * @param {ClientDataServiceUpdateManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateManagerNote(
      clientId: string,
      noteId: string,
      body: ClientDataServiceUpdateManagerNoteBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ManagerNote>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateManagerNote(
        clientId,
        noteId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateManagerNote']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ClientDataServiceApi - factory interface
 * @export
 */
export const ClientDataServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ClientDataServiceApiFp(configuration)
  return {
    /**
     *
     * @summary AddClientFile добавляет метаданные файла к клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientFile(
      clientId: string,
      body: ClientDataServiceAddClientFileBody,
      options?: any,
    ): AxiosPromise<V1AddClientFileResponse> {
      return localVarFp
        .clientDataServiceAddClientFile(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary AddClientTag вешает тег на клиента (DEV-1062), RemoveClientTag снимает.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientTagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientTag(
      clientId: string,
      body: ClientDataServiceAddClientTagBody,
      options?: any,
    ): AxiosPromise<V1ClientTagsResponse> {
      return localVarFp
        .clientDataServiceAddClientTag(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary AddManagerNote добавляет новую заметку менеджера к клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceAddManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddManagerNote(
      clientId: string,
      body: ClientDataServiceAddManagerNoteBody,
      options?: any,
    ): AxiosPromise<V1ManagerNote> {
      return localVarFp
        .clientDataServiceAddManagerNote(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary BulkUpdateClients массово обновляет stage и/или ответственного менеджера для списка клиентов.
     * @param {V1BulkUpdateClientsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceBulkUpdateClients(
      body: V1BulkUpdateClientsRequest,
      options?: any,
    ): AxiosPromise<V1BulkUpdateClientsResponse> {
      return localVarFp
        .clientDataServiceBulkUpdateClients(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {V1CreateArchiveReasonRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateArchiveReason(
      body: V1CreateArchiveReasonRequest,
      options?: any,
    ): AxiosPromise<V1CreateArchiveReasonResponse> {
      return localVarFp
        .clientDataServiceCreateArchiveReason(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateClient используется для создания \"полноценного\" клиента из CRM.
     * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClient(client: V1Client, options?: any): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceCreateClient(client, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateClientFromFormData используется для создания клиента из формы на сайте.
     * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClientFromFormData(
      client: V1Client,
      options?: any,
    ): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceCreateClientFromFormData(client, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateClientTask создаёт задачу по клиенту.
     * @param {string} clientId
     * @param {ClientDataServiceCreateClientTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClientTask(
      clientId: string,
      body: ClientDataServiceCreateClientTaskBody,
      options?: any,
    ): AxiosPromise<V1ClientTask> {
      return localVarFp
        .clientDataServiceCreateClientTask(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {V1CreateCountryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateCountry(
      body: V1CreateCountryRequest,
      options?: any,
    ): AxiosPromise<V1CreateCountryResponse> {
      return localVarFp
        .clientDataServiceCreateCountry(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {V1CreateLeadSourceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateLeadSource(
      body: V1CreateLeadSourceRequest,
      options?: any,
    ): AxiosPromise<V1CreateLeadSourceResponse> {
      return localVarFp
        .clientDataServiceCreateLeadSource(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteArchiveReason(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteArchiveReason(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteClientContact удаляет контакт клиента по ID.
     * @param {string} clientId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientContact(
      clientId: string,
      contactId: string,
      options?: any,
    ): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceDeleteClientContact(clientId, contactId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteClientFile удаляет метаданные файла.
     * @param {string} clientId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientFile(
      clientId: string,
      fileId: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteClientFile(clientId, fileId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteClientTask удаляет задачу (soft delete).
     * @param {string} clientId
     * @param {string} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientTask(
      clientId: string,
      taskId: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteClientTask(clientId, taskId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteCountry(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteCountry(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteLeadSource(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteLeadSource(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteManagerNote удаляет заметку менеджера.
     * @param {string} clientId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteManagerNote(
      clientId: string,
      noteId: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteManagerNote(clientId, noteId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetArchiveReasons возвращает справочник причин архивации клиента (DEV-1061).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetArchiveReasons(options?: any): AxiosPromise<V1GetArchiveReasonsResponse> {
      return localVarFp
        .clientDataServiceGetArchiveReasons(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetClient возвращает полную карточку одного клиента по его ID.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetClient(id: string, options?: any): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceGetClient(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetCountriesReferences возвращает список стран из справочника.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetCountriesReferences(options?: any): AxiosPromise<V1GetCountriesResponse> {
      return localVarFp
        .clientDataServiceGetCountriesReferences(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetDashboardMetrics возвращает метрики для дашборда (общее количество клиентов, прирост).
     * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - месяц) \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetDashboardMetrics(
      period?: string,
      options?: any,
    ): AxiosPromise<V1DashboardMetricsResponse> {
      return localVarFp
        .clientDataServiceGetDashboardMetrics(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLeadSources возвращает список доступных источников лидов.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetLeadSources(options?: any): AxiosPromise<V1GetLeadSourcesResponse> {
      return localVarFp
        .clientDataServiceGetLeadSources(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetManagers возвращает список менеджеров (доступен только для admin и hos).
     * @param {string} [role] manager (default) | support_manager
     * @param {boolean} [activeOnly] active_only&#x3D;true — только активные пользователи (DEV-717): для выбора, кому назначить/передать клиентов. По умолчанию false — отдаём всех носителей роли, включая уволенных: они нужны фильтрам и резолву имён (crm-vue).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetManagers(
      role?: string,
      activeOnly?: boolean,
      options?: any,
    ): AxiosPromise<V1GetManagersResponse> {
      return localVarFp
        .clientDataServiceGetManagers(role, activeOnly, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetTags возвращает справочник тегов клиента (DEV-1062).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetTags(options?: any): AxiosPromise<V1GetTagsResponse> {
      return localVarFp
        .clientDataServiceGetTags(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ARCHIVE REASONS CRUD (DEV-1061)
     * @param {boolean} [includeInactive] Включать ли неактивные причины
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListArchiveReasonsAdmin(
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<V1ListArchiveReasonsResponse> {
      return localVarFp
        .clientDataServiceListArchiveReasonsAdmin(includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListClientChangeLogs возвращает историю изменений клиента.
     * @param {string} clientId UUID клиента (обязательно)
     * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Фильтр по типу действия (опционально)   - CLIENT_CHANGE_ACTION_TYPE_CREATED: Клиент создан  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Поля клиента обновлены  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: Этап изменён  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: Статус изменён  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: Задача создана  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: Задача обновлена  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: Задача выполнена  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: Задача удалена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: Заметка добавлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: Заметка обновлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: Заметка удалена  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: Менеджер назначен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: Контакт добавлен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: Контакт удалён  - CLIENT_CHANGE_ACTION_TYPE_DELETED: Клиент удалён  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: Файл загружен  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: Файл скачан
     * @param {number} [limit] Лимит записей (по умолчанию 50)
     * @param {number} [offset] Смещение для пагинации
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientChangeLogs(
      clientId: string,
      actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
      limit?: number,
      offset?: number,
      options?: any,
    ): AxiosPromise<V1ListClientChangeLogsResponse> {
      return localVarFp
        .clientDataServiceListClientChangeLogs(clientId, actionType, limit, offset, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListClientData возвращает список клиентов с пагинацией.
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [responsibleManagerId] Существующие фильтры
     * @param {string} [leadSource]
     * @param {Array<string>} [statuses] 1.2.9.2.1. Фильтрация по множественным статусам (передаются UUID статусов)
     * @param {Array<string>} [leadSources] 1.2.9.2.2. Фильтрация по множественным источникам лидов (передаются UUID источников)
     * @param {string} [dateFrom] 1.2.9.2.3. Фильтрация по диапазону дат создания
     * @param {string} [dateTo]
     * @param {string} [searchQuery] 1.2.9.2.4. Полнотекстовый поиск по имени, email, телефону
     * @param {string} [language] 1.2.9.2.6. Фильтрация по языку общения клиента
     * @param {boolean} [hasDeal] 1.2.9.2.7. Фильтрация по наличию сделки true &#x3D; только клиенты со сделкой, false &#x3D; только без сделки, не указано &#x3D; все
     * @param {boolean} [isArchived] 1.2.9.2.8. Фильтрация по архивации true &#x3D; только архивные, false/не указано &#x3D; только активные
     * @param {boolean} [hasResponsibleManager] DEV-142. Фильтрация по наличию ответственного менеджера. true &#x3D; только клиенты с назначенным менеджером, false &#x3D; только без менеджера, не указано &#x3D; без фильтра. Используется пресетами «Мои/Без ответственного» для admin/hos на фронте; для не-admin/hos фильтр игнорируется по бизнес-логике.
     * @param {string} [agentId] DEV-232. Фильтр по агенту, приведшему клиента (clients.agent_id). UUID агента из auth.
     * @param {boolean} [hasAgent] DEV-281. Фильтрация по наличию агента, приведшего клиента (пресет «Агентские»). true &#x3D; только клиенты с агентом (clients.agent_id IS NOT NULL), false &#x3D; только без агента, не указано &#x3D; без фильтра.
     * @param {string} [agentDuplicateStatus] DEV-1005. Фильтр по статусу дубля от агента (clients.agent_duplicate_status). Значения: not_checked|unique|duplicate_pending|duplicate_confirmed|rejected. Пресет «Дубли» на фронте передаёт \&#39;duplicate_pending\&#39;. Скоуп по роли (rbac_helper) применяется поверх: manager видит только своих, admin/hos — всех.
     * @param {Array<string>} [tagKeys] DEV-1062. Фильтр по тегам клиента (client_tags.key): WARMING, TEST, AGENT_LEAD, DUPLICATE. Несколько ключей &#x3D; OR (клиент имеет хотя бы один из тегов).
     * @param {Array<string>} [archiveReasonIds] DEV-1061. Фильтр по причине архивации (clients.archive_reason_id, справочник archive_reasons). Несколько причин &#x3D; OR. Осмыслен вместе с is_archived&#x3D;true.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientData(
      paginationPage?: string,
      paginationPerPage?: string,
      responsibleManagerId?: string,
      leadSource?: string,
      statuses?: Array<string>,
      leadSources?: Array<string>,
      dateFrom?: string,
      dateTo?: string,
      searchQuery?: string,
      language?: string,
      hasDeal?: boolean,
      isArchived?: boolean,
      hasResponsibleManager?: boolean,
      agentId?: string,
      hasAgent?: boolean,
      agentDuplicateStatus?: string,
      tagKeys?: Array<string>,
      archiveReasonIds?: Array<string>,
      options?: any,
    ): AxiosPromise<V1ListClientDataResponse> {
      return localVarFp
        .clientDataServiceListClientData(
          paginationPage,
          paginationPerPage,
          responsibleManagerId,
          leadSource,
          statuses,
          leadSources,
          dateFrom,
          dateTo,
          searchQuery,
          language,
          hasDeal,
          isArchived,
          hasResponsibleManager,
          agentId,
          hasAgent,
          agentDuplicateStatus,
          tagKeys,
          archiveReasonIds,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListClientFiles возвращает список файлов клиента.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientFiles(
      clientId: string,
      options?: any,
    ): AxiosPromise<V1ListClientFilesResponse> {
      return localVarFp
        .clientDataServiceListClientFiles(clientId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListClientTasks возвращает задачи клиента.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientTasks(
      clientId: string,
      options?: any,
    ): AxiosPromise<V1ListClientTasksResponse> {
      return localVarFp
        .clientDataServiceListClientTasks(clientId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary COUNTRIES CRUD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListCountriesAdmin(options?: any): AxiosPromise<V1ListCountriesResponse> {
      return localVarFp
        .clientDataServiceListCountriesAdmin(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary LEAD SOURCES CRUD
     * @param {boolean} [includeInactive] Включать ли неактивные источники
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListLeadSourcesAdmin(
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<V1ListLeadSourcesResponse> {
      return localVarFp
        .clientDataServiceListLeadSourcesAdmin(includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary LogClientFileDownload логирует скачивание файла клиента.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceLogClientFileDownloadBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceLogClientFileDownload(
      clientId: string,
      fileId: string,
      body: ClientDataServiceLogClientFileDownloadBody,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceLogClientFileDownload(clientId, fileId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} clientId
     * @param {string} tagKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceRemoveClientTag(
      clientId: string,
      tagKey: string,
      options?: any,
    ): AxiosPromise<V1ClientTagsResponse> {
      return localVarFp
        .clientDataServiceRemoveClientTag(clientId, tagKey, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ResolveUsers — батч-резолв ФИО пользователей по id (вкл. уволенных), DEV-395. Любой аутентифицированный: имена менеджеров показываются на всех ролевых экранах (доски, списки), не только в hos/admin-отчётах.
     * @param {V1ResolveUsersRequest} body ResolveUsersRequest — батч-резолв ФИО пользователей по id (DEV-395), включая уволенных (soft-deleted): для отображения исторических ссылок на менеджеров в лидерборде/дашборде/сделках/клиентах. Доступен любому аутентифицированному.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceResolveUsers(
      body: V1ResolveUsersRequest,
      options?: any,
    ): AxiosPromise<V1ResolveUsersResponse> {
      return localVarFp
        .clientDataServiceResolveUsers(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SearchCities выполняет поиск городов по названию с поддержкой FTS.
     * @param {string} [query] Минимум 2 символа для поиска
     * @param {string} [countryId] Фильтр по стране (UUID)
     * @param {number} [limit] Лимит результатов (по умолчанию 10, макс 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceSearchCities(
      query?: string,
      countryId?: string,
      limit?: number,
      options?: any,
    ): AxiosPromise<V1SearchCitiesResponse> {
      return localVarFp
        .clientDataServiceSearchCities(query, countryId, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary TransferManagerClients передаёт весь живой портфель одного менеджера другому (DEV-717). Архивных и удалённых клиентов не трогает; активные сделки переезжают следом за клиентами.
     * @param {V1TransferManagerClientsRequest} body Запрос на передачу портфеля менеджера (DEV-717): все живые клиенты from_manager_id переезжают на to_manager_id. Архивные и удалённые клиенты остаются на прежнем менеджере.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceTransferManagerClients(
      body: V1TransferManagerClientsRequest,
      options?: any,
    ): AxiosPromise<V1TransferManagerClientsResponse> {
      return localVarFp
        .clientDataServiceTransferManagerClients(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateArchiveReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateArchiveReason(
      id: string,
      body: ClientDataServiceUpdateArchiveReasonBody,
      options?: any,
    ): AxiosPromise<V1UpdateArchiveReasonResponse> {
      return localVarFp
        .clientDataServiceUpdateArchiveReason(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateClient обновляет отдельные поля клиента (частичное обновление).
     * @param {string} clientId
     * @param {ClientDataServiceUpdateClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClient(
      clientId: string,
      body: ClientDataServiceUpdateClientBody,
      options?: any,
    ): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceUpdateClient(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateClientFile обновляет метаданные файла (например, display_name).
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceUpdateClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClientFile(
      clientId: string,
      fileId: string,
      body: ClientDataServiceUpdateClientFileBody,
      options?: any,
    ): AxiosPromise<V1UpdateClientFileResponse> {
      return localVarFp
        .clientDataServiceUpdateClientFile(clientId, fileId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateClientTask частично обновляет задачу (описание/срок/исполнитель/выполнение).
     * @param {string} clientId
     * @param {string} taskId
     * @param {ClientDataServiceUpdateClientTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClientTask(
      clientId: string,
      taskId: string,
      body: ClientDataServiceUpdateClientTaskBody,
      options?: any,
    ): AxiosPromise<V1ClientTask> {
      return localVarFp
        .clientDataServiceUpdateClientTask(clientId, taskId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateCountryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateCountry(
      id: string,
      body: ClientDataServiceUpdateCountryBody,
      options?: any,
    ): AxiosPromise<V1UpdateCountryResponse> {
      return localVarFp
        .clientDataServiceUpdateCountry(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {ClientDataServiceUpdateLeadSourceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateLeadSource(
      id: string,
      body: ClientDataServiceUpdateLeadSourceBody,
      options?: any,
    ): AxiosPromise<V1UpdateLeadSourceResponse> {
      return localVarFp
        .clientDataServiceUpdateLeadSource(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateManagerNote обновляет существующую заметку менеджера.
     * @param {string} clientId
     * @param {string} noteId
     * @param {ClientDataServiceUpdateManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateManagerNote(
      clientId: string,
      noteId: string,
      body: ClientDataServiceUpdateManagerNoteBody,
      options?: any,
    ): AxiosPromise<V1ManagerNote> {
      return localVarFp
        .clientDataServiceUpdateManagerNote(clientId, noteId, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ClientDataServiceApi - object-oriented interface
 * @export
 * @class ClientDataServiceApi
 * @extends {BaseAPI}
 */
export class ClientDataServiceApi extends BaseAPI {
  /**
   *
   * @summary AddClientFile добавляет метаданные файла к клиенту.
   * @param {string} clientId
   * @param {ClientDataServiceAddClientFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceAddClientFile(
    clientId: string,
    body: ClientDataServiceAddClientFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceAddClientFile(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary AddClientTag вешает тег на клиента (DEV-1062), RemoveClientTag снимает.
   * @param {string} clientId
   * @param {ClientDataServiceAddClientTagBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceAddClientTag(
    clientId: string,
    body: ClientDataServiceAddClientTagBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceAddClientTag(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary AddManagerNote добавляет новую заметку менеджера к клиенту.
   * @param {string} clientId
   * @param {ClientDataServiceAddManagerNoteBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceAddManagerNote(
    clientId: string,
    body: ClientDataServiceAddManagerNoteBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceAddManagerNote(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary BulkUpdateClients массово обновляет stage и/или ответственного менеджера для списка клиентов.
   * @param {V1BulkUpdateClientsRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceBulkUpdateClients(
    body: V1BulkUpdateClientsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceBulkUpdateClients(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {V1CreateArchiveReasonRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateArchiveReason(
    body: V1CreateArchiveReasonRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateArchiveReason(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateClient используется для создания \"полноценного\" клиента из CRM.
   * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateClient(client: V1Client, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateClient(client, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateClientFromFormData используется для создания клиента из формы на сайте.
   * @param {V1Client} client DEV-699: client.responsible_manager_id — явный выбор менеджера при создании (admin/hos/support_manager); пусто у support_manager → автораспределение.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateClientFromFormData(
    client: V1Client,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateClientFromFormData(client, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateClientTask создаёт задачу по клиенту.
   * @param {string} clientId
   * @param {ClientDataServiceCreateClientTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateClientTask(
    clientId: string,
    body: ClientDataServiceCreateClientTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateClientTask(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {V1CreateCountryRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateCountry(
    body: V1CreateCountryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateCountry(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {V1CreateLeadSourceRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateLeadSource(
    body: V1CreateLeadSourceRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateLeadSource(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteArchiveReason(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteArchiveReason(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteClientContact удаляет контакт клиента по ID.
   * @param {string} clientId
   * @param {string} contactId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteClientContact(
    clientId: string,
    contactId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteClientContact(clientId, contactId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteClientFile удаляет метаданные файла.
   * @param {string} clientId
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteClientFile(
    clientId: string,
    fileId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteClientFile(clientId, fileId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteClientTask удаляет задачу (soft delete).
   * @param {string} clientId
   * @param {string} taskId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteClientTask(
    clientId: string,
    taskId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteClientTask(clientId, taskId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteCountry(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteCountry(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteLeadSource(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteLeadSource(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteManagerNote удаляет заметку менеджера.
   * @param {string} clientId
   * @param {string} noteId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteManagerNote(
    clientId: string,
    noteId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteManagerNote(clientId, noteId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetArchiveReasons возвращает справочник причин архивации клиента (DEV-1061).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetArchiveReasons(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetArchiveReasons(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetClient возвращает полную карточку одного клиента по его ID.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetClient(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetClient(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetCountriesReferences возвращает список стран из справочника.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetCountriesReferences(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetCountriesReferences(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetDashboardMetrics возвращает метрики для дашборда (общее количество клиентов, прирост).
   * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - месяц) \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetDashboardMetrics(period?: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetDashboardMetrics(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLeadSources возвращает список доступных источников лидов.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetLeadSources(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetLeadSources(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetManagers возвращает список менеджеров (доступен только для admin и hos).
   * @param {string} [role] manager (default) | support_manager
   * @param {boolean} [activeOnly] active_only&#x3D;true — только активные пользователи (DEV-717): для выбора, кому назначить/передать клиентов. По умолчанию false — отдаём всех носителей роли, включая уволенных: они нужны фильтрам и резолву имён (crm-vue).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetManagers(
    role?: string,
    activeOnly?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetManagers(role, activeOnly, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetTags возвращает справочник тегов клиента (DEV-1062).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetTags(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetTags(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ARCHIVE REASONS CRUD (DEV-1061)
   * @param {boolean} [includeInactive] Включать ли неактивные причины
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListArchiveReasonsAdmin(
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListArchiveReasonsAdmin(includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListClientChangeLogs возвращает историю изменений клиента.
   * @param {string} clientId UUID клиента (обязательно)
   * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Фильтр по типу действия (опционально)   - CLIENT_CHANGE_ACTION_TYPE_CREATED: Клиент создан  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Поля клиента обновлены  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: Этап изменён  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: Статус изменён  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: Задача создана  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: Задача обновлена  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: Задача выполнена  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: Задача удалена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: Заметка добавлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: Заметка обновлена  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: Заметка удалена  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: Менеджер назначен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: Контакт добавлен  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: Контакт удалён  - CLIENT_CHANGE_ACTION_TYPE_DELETED: Клиент удалён  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: Файл загружен  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: Файл скачан
   * @param {number} [limit] Лимит записей (по умолчанию 50)
   * @param {number} [offset] Смещение для пагинации
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListClientChangeLogs(
    clientId: string,
    actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
    limit?: number,
    offset?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListClientChangeLogs(clientId, actionType, limit, offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListClientData возвращает список клиентов с пагинацией.
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [responsibleManagerId] Существующие фильтры
   * @param {string} [leadSource]
   * @param {Array<string>} [statuses] 1.2.9.2.1. Фильтрация по множественным статусам (передаются UUID статусов)
   * @param {Array<string>} [leadSources] 1.2.9.2.2. Фильтрация по множественным источникам лидов (передаются UUID источников)
   * @param {string} [dateFrom] 1.2.9.2.3. Фильтрация по диапазону дат создания
   * @param {string} [dateTo]
   * @param {string} [searchQuery] 1.2.9.2.4. Полнотекстовый поиск по имени, email, телефону
   * @param {string} [language] 1.2.9.2.6. Фильтрация по языку общения клиента
   * @param {boolean} [hasDeal] 1.2.9.2.7. Фильтрация по наличию сделки true &#x3D; только клиенты со сделкой, false &#x3D; только без сделки, не указано &#x3D; все
   * @param {boolean} [isArchived] 1.2.9.2.8. Фильтрация по архивации true &#x3D; только архивные, false/не указано &#x3D; только активные
   * @param {boolean} [hasResponsibleManager] DEV-142. Фильтрация по наличию ответственного менеджера. true &#x3D; только клиенты с назначенным менеджером, false &#x3D; только без менеджера, не указано &#x3D; без фильтра. Используется пресетами «Мои/Без ответственного» для admin/hos на фронте; для не-admin/hos фильтр игнорируется по бизнес-логике.
   * @param {string} [agentId] DEV-232. Фильтр по агенту, приведшему клиента (clients.agent_id). UUID агента из auth.
   * @param {boolean} [hasAgent] DEV-281. Фильтрация по наличию агента, приведшего клиента (пресет «Агентские»). true &#x3D; только клиенты с агентом (clients.agent_id IS NOT NULL), false &#x3D; только без агента, не указано &#x3D; без фильтра.
   * @param {string} [agentDuplicateStatus] DEV-1005. Фильтр по статусу дубля от агента (clients.agent_duplicate_status). Значения: not_checked|unique|duplicate_pending|duplicate_confirmed|rejected. Пресет «Дубли» на фронте передаёт \&#39;duplicate_pending\&#39;. Скоуп по роли (rbac_helper) применяется поверх: manager видит только своих, admin/hos — всех.
   * @param {Array<string>} [tagKeys] DEV-1062. Фильтр по тегам клиента (client_tags.key): WARMING, TEST, AGENT_LEAD, DUPLICATE. Несколько ключей &#x3D; OR (клиент имеет хотя бы один из тегов).
   * @param {Array<string>} [archiveReasonIds] DEV-1061. Фильтр по причине архивации (clients.archive_reason_id, справочник archive_reasons). Несколько причин &#x3D; OR. Осмыслен вместе с is_archived&#x3D;true.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListClientData(
    paginationPage?: string,
    paginationPerPage?: string,
    responsibleManagerId?: string,
    leadSource?: string,
    statuses?: Array<string>,
    leadSources?: Array<string>,
    dateFrom?: string,
    dateTo?: string,
    searchQuery?: string,
    language?: string,
    hasDeal?: boolean,
    isArchived?: boolean,
    hasResponsibleManager?: boolean,
    agentId?: string,
    hasAgent?: boolean,
    agentDuplicateStatus?: string,
    tagKeys?: Array<string>,
    archiveReasonIds?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListClientData(
        paginationPage,
        paginationPerPage,
        responsibleManagerId,
        leadSource,
        statuses,
        leadSources,
        dateFrom,
        dateTo,
        searchQuery,
        language,
        hasDeal,
        isArchived,
        hasResponsibleManager,
        agentId,
        hasAgent,
        agentDuplicateStatus,
        tagKeys,
        archiveReasonIds,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListClientFiles возвращает список файлов клиента.
   * @param {string} clientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListClientFiles(clientId: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListClientFiles(clientId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListClientTasks возвращает задачи клиента.
   * @param {string} clientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListClientTasks(clientId: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListClientTasks(clientId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary COUNTRIES CRUD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListCountriesAdmin(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListCountriesAdmin(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary LEAD SOURCES CRUD
   * @param {boolean} [includeInactive] Включать ли неактивные источники
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListLeadSourcesAdmin(
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListLeadSourcesAdmin(includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary LogClientFileDownload логирует скачивание файла клиента.
   * @param {string} clientId
   * @param {string} fileId
   * @param {ClientDataServiceLogClientFileDownloadBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceLogClientFileDownload(
    clientId: string,
    fileId: string,
    body: ClientDataServiceLogClientFileDownloadBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceLogClientFileDownload(clientId, fileId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} clientId
   * @param {string} tagKey
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceRemoveClientTag(
    clientId: string,
    tagKey: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceRemoveClientTag(clientId, tagKey, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ResolveUsers — батч-резолв ФИО пользователей по id (вкл. уволенных), DEV-395. Любой аутентифицированный: имена менеджеров показываются на всех ролевых экранах (доски, списки), не только в hos/admin-отчётах.
   * @param {V1ResolveUsersRequest} body ResolveUsersRequest — батч-резолв ФИО пользователей по id (DEV-395), включая уволенных (soft-deleted): для отображения исторических ссылок на менеджеров в лидерборде/дашборде/сделках/клиентах. Доступен любому аутентифицированному.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceResolveUsers(
    body: V1ResolveUsersRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceResolveUsers(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SearchCities выполняет поиск городов по названию с поддержкой FTS.
   * @param {string} [query] Минимум 2 символа для поиска
   * @param {string} [countryId] Фильтр по стране (UUID)
   * @param {number} [limit] Лимит результатов (по умолчанию 10, макс 50)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceSearchCities(
    query?: string,
    countryId?: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceSearchCities(query, countryId, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary TransferManagerClients передаёт весь живой портфель одного менеджера другому (DEV-717). Архивных и удалённых клиентов не трогает; активные сделки переезжают следом за клиентами.
   * @param {V1TransferManagerClientsRequest} body Запрос на передачу портфеля менеджера (DEV-717): все живые клиенты from_manager_id переезжают на to_manager_id. Архивные и удалённые клиенты остаются на прежнем менеджере.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceTransferManagerClients(
    body: V1TransferManagerClientsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceTransferManagerClients(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {ClientDataServiceUpdateArchiveReasonBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateArchiveReason(
    id: string,
    body: ClientDataServiceUpdateArchiveReasonBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateArchiveReason(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateClient обновляет отдельные поля клиента (частичное обновление).
   * @param {string} clientId
   * @param {ClientDataServiceUpdateClientBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateClient(
    clientId: string,
    body: ClientDataServiceUpdateClientBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateClient(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateClientFile обновляет метаданные файла (например, display_name).
   * @param {string} clientId
   * @param {string} fileId
   * @param {ClientDataServiceUpdateClientFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateClientFile(
    clientId: string,
    fileId: string,
    body: ClientDataServiceUpdateClientFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateClientFile(clientId, fileId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateClientTask частично обновляет задачу (описание/срок/исполнитель/выполнение).
   * @param {string} clientId
   * @param {string} taskId
   * @param {ClientDataServiceUpdateClientTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateClientTask(
    clientId: string,
    taskId: string,
    body: ClientDataServiceUpdateClientTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateClientTask(clientId, taskId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {ClientDataServiceUpdateCountryBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateCountry(
    id: string,
    body: ClientDataServiceUpdateCountryBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateCountry(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {ClientDataServiceUpdateLeadSourceBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateLeadSource(
    id: string,
    body: ClientDataServiceUpdateLeadSourceBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateLeadSource(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateManagerNote обновляет существующую заметку менеджера.
   * @param {string} clientId
   * @param {string} noteId
   * @param {ClientDataServiceUpdateManagerNoteBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateManagerNote(
    clientId: string,
    noteId: string,
    body: ClientDataServiceUpdateManagerNoteBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateManagerNote(clientId, noteId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const ClientDataServiceListClientChangeLogsActionTypeEnum = {
  Invalid: 'CLIENT_CHANGE_ACTION_TYPE_INVALID',
  Created: 'CLIENT_CHANGE_ACTION_TYPE_CREATED',
  Updated: 'CLIENT_CHANGE_ACTION_TYPE_UPDATED',
  StageChanged: 'CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED',
  StatusChanged: 'CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED',
  TaskCreated: 'CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED',
  TaskUpdated: 'CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED',
  TaskCompleted: 'CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED',
  TaskDeleted: 'CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED',
  NoteAdded: 'CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED',
  NoteUpdated: 'CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED',
  NoteDeleted: 'CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED',
  ManagerAssigned: 'CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED',
  ContactAdded: 'CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED',
  ContactRemoved: 'CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED',
  Deleted: 'CLIENT_CHANGE_ACTION_TYPE_DELETED',
  FileUploaded: 'CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED',
  FileDownloaded: 'CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED',
} as const
export type ClientDataServiceListClientChangeLogsActionTypeEnum =
  (typeof ClientDataServiceListClientChangeLogsActionTypeEnum)[keyof typeof ClientDataServiceListClientChangeLogsActionTypeEnum]
